import { render, staticRenderFns } from "./SharedLinkDeleteDialogBox.vue?vue&type=template&id=3f6446de&scoped=true&"
import script from "./SharedLinkDeleteDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkDeleteDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6446de",
  null
  
)

export default component.exports